import React,{useState,useContext} from 'react';
import {  
  Card,  
  Alert,
  Row,
  Col,
  Form,
  Button,
  Spinner
} from 'react-bootstrap';

import _ from 'lodash';
import UserContext from './../../contexts/UserContext';
import {Uploader} from '../../components';
import Utils from '../../Utils';

const Step2 = (props) => {

  const videosize_in_mb = _.get(process.env,'REACT_APP_MAX_VIDEO_SIZE',10);
  const scormsize_in_mb = _.get(process.env,'REACT_APP_MAX_SCORM_SIZE',50);
  const {getPkgSize} = useContext(UserContext);
  const [video,setVideo] = useState('');
  const [errMsg,setErrMsg] = useState('');
  const [title, setTitle] = useState('');
  const [uploading, setUploading] = useState(false);
 
  const renderInfo = () => {
    return <Card className="card-box blk text-center">
      <Card.Body className="p-5">
        
        <h3 className="mt-3 mb-5">Upload Video</h3>

        <p>Upload your video and start building your SCORM.</p>

        <p>After uploading your video, you can add/edit slides and review your SCORM before publishing & downloading it.</p>

      </Card.Body>  
    </Card>
  }

  const onUploadVideo = (attr,status) => {
    if(status==='error_file_size'){
      setErrMsg(`You have uploaded ${(attr.meta.size/1024/1024).toFixed(1)} MB file, however, 
      the acceptable maximum file size is ${videosize_in_mb} MB. Try again with an acceptable sized file.`);
      window.setTimeout(function(){
        setErrMsg('');
        setUploading(false);
        setVideo('');
      }, 5000);
    }else{
      let file_size = (status.size/1024/1024).toFixed(1);
      let tot_size = file_size + getPkgSize();
      if(tot_size > scormsize_in_mb){
        setErrMsg(`Total SCROM size allowed is ${scormsize_in_mb} MB,You have used ${getPkgSize()} MB.`);
        return;
      }else{
        setErrMsg('');
        setVideo(attr);   
        props.onUpload(attr,file_size);
        setUploading(false);        
      }      
    }
  }

  const startUploading = (attr, status) =>{
    if(status==='rejected_file_type'){
      setUploading(false);
      window.alert('Please follow instructions to upload file');
    }else{
      setUploading('Please wait... We are processing your file..');
    }
  }

  const setFormTitle = (e) =>{
    const frm = e.currentTarget;
    e.preventDefault();
    if(frm.title.value === ''){
      window.alert("Please Enter title");
      frm.title.focus();
      return false;
    }
    setTitle(frm.title.value);
  }

  const renderUploadBase = () => {
    return <>      
    <div className="uploadVideo">
    <Row>
      <Col lg={12} className="text-center">
        {errMsg !== '' && <Alert variant="danger" className="p-3"><i className="fa fa-exclamation-circle" /> {errMsg} </Alert>}
        {errMsg === '' && <>
          {(video === '' && uploading===false) && <span>
            No Video selected.
          </span>}
          {uploading && <>
              
              {uploading}   <Spinner animation="border" variant="dark" />
            </>
          }
          {video !=='' && <span>
            Video file selected <span className="fa fa-arrow-up"/> <span className="fa fa-close clickable" title="Remove" onClick={() => onUploadVideo(false)} />
          </span>}
        </>}
      </Col>
    </Row>  

      <div>
        <Uploader 
        instructions={`To upload your video (max allowed ${videosize_in_mb} MB), click here or drag/drop your video here`}
        accept="video/*" 
        maxSizeBytes={videosize_in_mb*1024*1024} 
        uploadUrl={Utils.apiUrl('saveupload')} 
        onUpload={onUploadVideo} 
        onSubmit={startUploading} />
      </div>    
      </div>
    </>;
  }

  const renderTitleBox = () => {
    return <Form onSubmit={setFormTitle}>      
     
      <Row>
        <Col lg={6} className="text-left">
          Enter Title : 
        </Col>
        <Col lg={6} className="text-left">
          <Form.Control type="input" name="title" />
        </Col>        
      </Row>  
      <Row>
        <Col >
            <Button type="submit">Save</Button>
        </Col>
      </Row>    
    </Form>;
  }
  
  return <Row className="uploadImageVideopage">
    <Col className="mt-3">{renderInfo()}</Col>
    <Col className="mt-3">{renderUploadBase()}</Col>    
  </Row>;
}

export default Step2;